export default __webpack_public_path__ + "static/media/commentarylogo-icon.37831046.png";